import { Component } from '@angular/core';

@Component({
    selector: 'edl-public',
    templateUrl: './edl-public.component.html',
    styleUrls: ['./edl-public.component.scss']
})

export class EdlPublicComponent { 

    
}